import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import './UsageLimitModal.css';

const TIERS = [
  { name: 'free', displayName: 'Free', price: 0 },
  { name: 'essential', displayName: 'Essential', price: 9 },
  { name: 'plus', displayName: 'Plus', price: 24 },
  { name: 'premium', displayName: 'Premium', price: 49 },
];

const TIER_ORDER = ['free', 'essential', 'plus', 'premium'];

function FeatureAccessModal({ data, onClose }) {
  const navigate = useNavigate();
  const { tier } = useUser();
  const currentTier = tier || 'free';

  if (!data) return null;

  const { featureName, permissionType, tierDisplay, otherToolName, otherToolRoute } = data;

  // Get tiers above the user's current tier
  const currentIndex = TIER_ORDER.indexOf(currentTier);
  const upgradeTiers = TIERS.filter((_, i) => i > currentIndex);

  const isFeatureDisabled = permissionType === 'feature_disabled';

  const handleViewPlans = () => {
    onClose();
    navigate('/pricing');
  };

  const handleTryOtherTool = () => {
    onClose();
    navigate(otherToolRoute);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="usage-limit-overlay" onClick={handleOverlayClick}>
      <div className="usage-limit-card">
        <button className="usage-limit-close" onClick={onClose} aria-label="Close">
          &#x2715;
        </button>

        <h2 className="usage-limit-title">
          {isFeatureDisabled
            ? `${featureName} is currently unavailable`
            : `${featureName} is not included in your plan`
          }
        </h2>

        <div style={{ marginBottom: '24px' }}>
          <p style={{ color: '#aeb9cc', fontSize: '15px', lineHeight: 1.6, margin: 0 }}>
            {isFeatureDisabled
              ? `The ${featureName} feature is temporarily unavailable. We're working on bringing it to you soon.`
              : `Your ${tierDisplay || currentTier} plan does not include access to ${featureName}. Upgrade your plan to unlock this feature and more.`
            }
          </p>
        </div>

        {/* Tier comparison - only show for tier access issues, not globally disabled features */}
        {!isFeatureDisabled && upgradeTiers.length > 0 && (
          <div className="usage-limit-tiers">
            <p className="usage-limit-tiers-heading">Upgrade to unlock</p>
            {upgradeTiers.map((t) => (
              <div key={t.name} className="usage-limit-tier-row">
                <span>
                  <span className="usage-limit-tier-name">{t.displayName}</span>
                  <span className="usage-limit-tier-price">
                    {t.price === 0 ? '' : ` ($${t.price}/mo)`}
                  </span>
                </span>
                <span className="usage-limit-tier-limit">
                  Included
                </span>
              </div>
            ))}
          </div>
        )}

        {/* CTAs */}
        <div className="usage-limit-buttons">
          {!isFeatureDisabled && (
            <button className="usage-limit-button-primary" onClick={handleViewPlans}>
              View Plans
            </button>
          )}
          <button className="usage-limit-button-secondary" onClick={handleTryOtherTool}>
            Try the {otherToolName}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeatureAccessModal;
